<template>
    <div>
        <div v-for="(field, index) in customFields" class="my-2 w-full flex" :class="[(project ? 'flex-row ml-2' : 'flex-column')]">
            <label class="text-grey-darkest text-sm" :class="[(project ? 'w-1/2 md:w-1/3' : ''), (customFieldErrors.errors && customFieldErrors.errors.hasOwnProperty(field.label_value) ? 'text-red' : '')]"
                   :for="field.label_value">
                {{ field.label_value }}
            </label>
            <div v-if="field.type == 1 || field.type == 3" :class="[(project ? 'w-1/2 md:w-2/3' : '')]">
                <select class="appearance-none p-1 bg-white border-1 focus:outline-none rounded text-grey-darkest text-sm w-full field-height-update"
                        :class="{'border-red' : customFieldErrors.errors ? customFieldErrors.errors.hasOwnProperty(field.label_value) : ''}"
                        v-model="form[field.id]" :name="field.label_value"
                        :id="field.name.replace(/\s+/g, '-') + '-' + field.id"
                        @change="resetValidationErrors(field.label_value)">
                    <option value="0"></option>
                    <option v-for="option in field.options" :value="option.id"> {{ option.name }} </option>
                </select>
                <div class="text-red text-xs" v-if="customFieldErrors.errors && customFieldErrors.errors.hasOwnProperty(field.label_value)">
                    {{ customFieldErrors.errors && customFieldErrors.errors[field.label_value] ? customFieldErrors.errors[field.label_value][0] : '' }}
                </div>
            </div>
            <div v-if="field.type == 2" :class="[(project ? 'w-1/2 md:w-2/3' : '')]">
                <input class="appearance-none p-1 border-1 focus:outline-none rounded text-grey-darkest text-sm w-full field-height-update"
                       :class="{'border-red' : customFieldErrors.errors ? customFieldErrors.errors.hasOwnProperty(field.label_value) : ''}"
                       v-model="form[field.id]" :name="field.label_value"
                       :id="field.name.replace(/\s+/g, '-') + '-' + field.id"
                       @input="resetValidationErrors(field.label_value)">
                <div class="text-red text-xs" v-if="customFieldErrors.errors && customFieldErrors.errors.hasOwnProperty(field.label_value)">
                    {{ customFieldErrors.errors && customFieldErrors.errors[field.label_value] ? customFieldErrors.errors[field.label_value][0] : '' }}
                </div>
            </div>
            <div v-if="field.type == 4" :class="[(project ? 'w-1/2 md:w-2/3' : '')]">
                <datepicker :input-class="[('cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 field-height-update'), (customFieldErrors.errors && customFieldErrors.errors.hasOwnProperty(field.label_value) ? 'border-red' : '')]"
                            v-model="form[field.id]" :name="field.label_value"
                            :id="field.name.replace(/\s+/g, '-') + '-' + field.id"
                            :format="masks.date_mask"
                            @input="resetValidationErrors(field.label_value)">
                </datepicker>
                <div class="text-red text-xs" v-if="customFieldErrors.errors && customFieldErrors.errors.hasOwnProperty(field.label_value)">
                    {{ customFieldErrors.errors && customFieldErrors.errors[field.label_value] ? customFieldErrors.errors[field.label_value][0] : '' }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../utils/form";
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'project-record-detail-custom-fields',
    props: ['project', 'masks', 'customFieldErrors'],
    components: {Datepicker},
    data() {
        return {
            customFields: [],
            form: {}
        }
    },
    created() {
        this.fetchCustomFields();
    },
    methods: {
        fetchCustomFields() {
            let self = this;

            axios.get(route('api.record-detail-custom-field.index') + '?project=true').then(({data}) => {
                self.customFields = data.data.sort((a,b) => a.label_order - b.label_order);

                let customForm = [];
                for(let field in self.customFields) {
                    customForm[self.customFields[field].id] = '';
                }
                self.form = new Form(customForm);

                if(self.project) {
                    self.fetchCustomFieldValues();
                }
            });
        },
        fetchCustomFieldValues() {
            let self = this;

            axios.get(route('api.r-d-custom-field-value.index') + `?project_id=${this.project.id}`).then(({data}) => {
                data.data.forEach(field => {
                    let finalValue = field.value;
                    if(field.record_detail_custom_field_type == 4) {
                        finalValue = moment(field.value).utc().format();
                    }
                    self.form[field.record_detail_custom_field_id] = finalValue;
                });
            });
        },
        getCustomFieldForm() {
            return this.form;
        },
        resetValidationErrors(field) {
            if(field && this.customFieldErrors.errors[field]) {
                delete this.customFieldErrors.errors[field];
            }
        },
    }
}
</script>

<style scoped>
</style>
